<div class="content">
  <svg-icon key="error-400"></svg-icon>
  <div class="error-title">{{errorTitle}}</div>
  <div class="error-description">{{errorDescription}}</div>
  <div class="more-info">
    @if (errors && errors[0]?.uuid) {
      <h3>{{'std_PageError_Uiid' | NTSTranslate}}:&nbsp;</h3>
      }@if (errors[0]?.uuid) {
      <p>{{errors[0]?.uuid}}<br></p>
    }
    <h3>{{'std_PageError_DetailTitle' | NTSTranslate}}:&nbsp;</h3>
    <p>{{errorDetailDescription}}@if (showDetailMore && !expandDetailMore) {
      <span>...</span>
      }@if (expandDetailMore) {
      <span
      >{{errorDetailMoreDescription}}</span>
    }</p>
  </div>

  <nts-text-button [title]="'std_PageError_AdditionalInfoTitle' | NTSTranslate"
    [label]="'std_PageError_AdditionalInfoTitle' | NTSTranslate" (onClicked)="showAdditionalInfo()">
  </nts-text-button>

  <nts-filled-button [type]="1" [title]="'std_GoBack_Dashboard' | NTSTranslate"
    [label]="'std_GoBack_Dashboard' | NTSTranslate" (onClicked)="redirectToDashBoard()">
  </nts-filled-button>
</div>
